<template>
  <div class="user-manage">
    <!-- 查找参数区 -->
    <div class="filter-container">
      <el-input placeholder="请输入用户名" v-model="listQuery.params.username" style="width: 200px" class="filter-item"
        maxlength="20" @input="e => listQuery.params.username = e.replace(/[^0-9a-zA-Z_]+$/g,'')"></el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
        @click="handleFilter">
        搜索
      </el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit"
        @click="handleCreate">
        新建
      </el-button>
    </div>

    <!-- 数据列表区 -->
    <el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%;align: center;">

      <el-table-column prop="userId" label="用户ID" align="center" v-if="false">
      </el-table-column>
      <el-table-column prop="username" label="用户名" align="center">
      </el-table-column>
      <el-table-column prop="entityName" label="所属单位" align="center">
      </el-table-column>
      <el-table-column prop="roleName" label="角色" align="center">
      </el-table-column>
<!--      <el-table-column prop="appAvailable" label="App权限" align="center" :formatter="formatAppAuthorityToName">
      </el-table-column> -->
      <el-table-column prop="phone" label="联系方式" align="center">
      </el-table-column>
      <el-table-column prop="createdate" label="创建时间" width="200" align="center">
      </el-table-column>
      <el-table-column prop="lastlogin" label="上次登录时间" width="200" align="center">
      </el-table-column>
      <el-table-column prop="logintimes" label="登录次数" align="center">
      </el-table-column>
      <el-table-column prop="operator" label="操作" width="200" align="center">
        <template v-slot:="{row,$index}">
          <el-button type="primary" size="mini" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <pagination :total="totalCounts" @pagination="handlePageChange">
    </pagination>

    <!-- 编辑用户dialog -->
    <el-dialog title="编辑用户" :visible.sync="dialogFormVisible" :before-close="handleClose">
      <el-form :model="editedUser" ref="editedUser" :rules="editedUserRules" label-width="120px">

        <el-form-item label="所属单位" prop="entityId">
          <el-select v-model="editedUser.entityId" placeholder="请选择所属单位" style="width:100%" :disabled="true">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户名" prop="username">
          <el-input v-model="editedUser.username" placeholder="请输入用户名" maxlength="20"
            @keyup.native="trimLr(editedUser.username)" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="角色" prop="roleId">
          <!-- 目标用户是超级管理员,不可修改 -->
          <el-select v-if="editedUser.roleId==5" v-model="editedUser.roleId" placeholder="请选择角色" style="width:100%" :disabled="true">
            <el-option :label="'superadmin'" :value="5"></el-option>
          </el-select>
          <!-- 否则可以修改 -->
          <el-select v-if="editedUser.roleId!=5" v-model="editedUser.roleId" placeholder="请选择角色" style="width:100%">
            <el-option v-for="item in editRoleIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
		
<!-- 		<el-form-item label="APP权限" prop="appAvailable">
		  <el-select v-model="editedUser.appAvailable" placeholder="请选择APP权限" style="width:100%">
		    <el-option v-for="(item,index) in appAvailableOptions" :key="index" :label="item" :value="index">
		    </el-option>
		  </el-select>
		</el-form-item> -->

        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="editedUser.phone" placeholder="请输入联系方式" :maxlength="maxlengthPhone"
            @input="e => editedUser.phone = e.replace(/[^\d\-]/g,'')"
            @onkeypress="e=> editedUser.phone=e.replace(/[\s+]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="密码操作" prop="isResetPassword">
          <el-radio v-model="isResetPassword" :label="0">无</el-radio>
          <el-radio v-model="isResetPassword" :label="1">修改密码</el-radio>
          <el-radio v-model="isResetPassword" :label="2">默认密码</el-radio>
        </el-form-item>
        <el-form-item v-if="isResetPassword===1" label="密码" prop="password">
          <el-input v-model="editedUser.password" placeholder="请输入密码" show-password
            @input="e => editedUser.password = e.replace(/[^0-9a-zA-Z]+$/g,'')" maxlength="20"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
		<el-button type="danger" @click="offline()">强制下线</el-button>
        <el-button @click="cancelEditUser()">取 消</el-button>
        <el-button type="primary" @click="editUser()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新建用户dialog -->
    <el-dialog title="新建用户" :visible.sync="createUserDialog" :before-close="cancelUser">
      <!-- 新建用户表单 -->
      <el-form :model="newUser" :rules="newUserRules" ref="newUser" label-position="right" label-width="80px">

        <el-form-item label="所属单位" prop="entityId">
          <el-select v-model="newUser.entityId" placeholder="请选择所属单位" style="width:100%" @change="entityChange">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户名" prop="username">
          <el-input v-model="newUser.username" placeholder="请输入用户名" maxlength="20"
            @keyup.native="trimLr(newUser.username)"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="newUser.password" autocomplete="new-password" placeholder="请输入密码" show-password
            @input="e => newUser.password = e.replace(/[^0-9a-zA-Z]+$/g,'')" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="rePassword">
          <el-input v-model="newUser.rePassword" placeholder="请再次输入密码" show-password
            @input="e => newUser.rePassword = e.replace(/[^0-9a-zA-Z]+$/g,'')" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="角色" prop="roleId">
          <el-select v-model="newUser.roleId" placeholder="请选择角色" style="width:100%">
            <el-option v-for="item in roleIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
		
<!-- 		<el-form-item label="APP权限" prop="appAvailable">
		  <el-select v-model="newUser.appAvailable" placeholder="请选择请选择APP权限" style="width:100%">
		    <el-option v-for="(item,index) in appAvailableOptions" :key="index" :label="item" :value="index">
		    </el-option>
		  </el-select>
		</el-form-item> -->

        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="newUser.phone" placeholder="请输入联系方式" :maxlength="maxlengthPhone"
		  @input="e => newUser.phone = e.replace(/[^\d\-]/g,'')"
		  @onkeypress="e=> newUser.phone=e.replace(/[\s+]/g,'')"></el-input>
		<!-- @keyup.native="check_phone()"  -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelUser()">取 消</el-button>
        <el-button type="primary" @click="createUser()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Pagination from '@/components/common/Pagination'
  import {
    userList
  } from '@/api/user.js'
  import {
    formatDate
  } from '@/utils/date'
  // import {
  //   resetPW
  // } from '@/api/user.js'
  import {
    deleteUser
  } from '@/api/user.js'
  import {
    getRoles,
    roleList
  } from '@/api/role.js'
  import {
    addUser
  } from '@/api/user.js'
  import {
    updateUser,userOffline
  } from '@/api/user.js'

  import {mqttPushUserOffline} from '@/api/mqtt.js'	

  export default {
    name: 'UserManage',
    components: {
      Pagination,
    },
    data() {
		
      var validateUserName = (rule, value, callback) => {
        let r = /^[0-9a-zA-Z_]+$/;
        if (!r.test(value)) {
          callback(new Error('用户名只能是字母、数字和下划线!'));
        }
        callback();
      };
	  
      var validatePhone = (rule, value, callback) => {
        // let r = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
        // if (this.error_input === false) {
        //   callback(new Error('手机号格式不正确!'));
        // }
        // callback(new Error(""));
		
		let phone = value;
		let validatedPhone = false;
		if (phone.length == 11 && phone.indexOf("-") == -1) {
		  this.maxlengthPhone = 11;
		}
		if (phone.indexOf("-") != -1) { //座机校验
		  this.maxlengthPhone = 13;
		  // let reg = /^((d{3,4})|d{3,4}-|s)?d{7,14}$/;
		  let reg = /^(0\d{3,4}-\d{7,8})$/
		  // 0\d{2,3}-\d{7,8}
		  if (!(reg.test(phone))) {
		    validatedPhone = false
		  } else {
		    validatedPhone = true;
		  }
		} else { //手机校验
		 let reg = /^1[3456789]\d{9}$/
		 if(!(reg.test(phone))) {
			validatedPhone = false;
		  } else {
		    validatedPhone = true;
		  }
		  console.log(validatedPhone);
		}
		if(!validatedPhone) {
		  console.log("手机号格式不正确")
		  callback(new Error('手机号格式不正确!'));
		} else {
		  callback();
		}
		
      };
	  
      var validatePass = (rule, value, callback) => {
        let r = /^[0-9a-zA-Z]+$/;
        if (!r.test(value) || value.length < 4) {
          callback(new Error('密码只能是4字符以上的数字和字母的组合'));
        } else {
          if (this.newUser.rePassword !== '') {
            this.$refs.newUser.validateField('rePassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.newUser.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };

      var validateEditedPhone = (rule,value,callback) =>{     
        let phone = value;
        let validatedPhone = false;
        if (phone.length == 11 && phone.indexOf("-") == -1) {
          this.maxlengthPhone = 11;
        }
        if (phone.indexOf("-") != -1) { //座机校验
          this.maxlengthPhone = 13;
          // let reg = /^((d{3,4})|d{3,4}-|s)?d{7,14}$/;
          let reg = /^(0\d{3,4}-\d{7,8})$/
          // 0\d{2,3}-\d{7,8}
          if (!(reg.test(phone))) {
            validatedPhone = false
          } else {
            validatedPhone = true;
          }
        } else { //手机校验
		 let reg = /^1[3456789]\d{9}$/
         if(!(reg.test(phone))) {
			validatedPhone = false;
          } else {
            validatedPhone = true;
          }
          console.log(validatedPhone);
        }
        if(!validatedPhone) {
          console.log("手机号格式不正确")
          callback(new Error('手机号格式不正确!'));
        } else {
          callback();
        }
      };

      var validateEditedPassword = (rule,value,callback) =>{
        let r = /^[0-9a-zA-Z]+$/;
        if (!r.test(value) || value.length < 4) {
          callback(new Error('密码只能是4字符以上的数字和字母的组合'));
        } else {
          callback();
        }
      }



      return {
        maxlengthPhone: 11,
        error_input: false,
        listLoading: true,
        listData: [],
        totalCounts: 0,
        //搜索条件
        listQuery: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            username: undefined
          },
          fuzzySearch: true
        },
        
        formLabelWidth: '120px',
        cur_row: null,

        //新建用户
        //用于控制新建用户模态框的显示
        createUserDialog: false,
        //新建的用户对象
        newUser: {
          entityId: null,
          username: '',
          password: '',
          rePassword: '',
          roleId: null,
          phone: '',
		  appAvailable:null
        },
        //新建用户的校验规则
        newUserRules: {
          entityId: [{
            required: true,
            message: '请选择所属单位',
            trigger: 'change'
          }],
          username: [{
              required: true,
              message: '请输入用户名',
              trigger: 'blur'
            },
            {
              validator: validateUserName,
              trigger: 'blur'
            }
          ],
          password: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          rePassword: [{
            validator: validatePass2,
            trigger: 'blur'
          }],
          roleId: [{
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }],
          phone: [{
            validator: validatePhone,
            trigger: 'blur'
          }],
		  appAvailable: [{
           required: true,
           message: '请选择APP权限',
           trigger: 'change'
          }],
        },
        entityIdOptions: [],
        roleIdOptions: [],
        //App操作权限选项//固定
        appAvailableOptions: {
          0:"无",
          1:"有"
        },

        //编辑用户
        //用于控制编辑用户模态框的显示
        dialogFormVisible: false,
        //编辑的用户对象
        editedUser: {
          id: null,
          entityId: null,
          username: '',
          roleId: null,
          phone: '',
          password:"",
		  appAvailable:null
        },
        isResetPassword: 0,
        //用户编辑模态框角色下拉栏
        //不使用roleIdOptions是为了避免影响新建用户功能
        editRoleIdOptions: [],
        editedUserRules: {
          roleId: [{
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }],
          phone: [{
            validator: validateEditedPhone,
            trigger: 'blur'
          }],
          password: [{
            validator: validateEditedPassword,
            trigger: 'blur'
          }],
          appAvailable: [{
            required: true,
            message: '请选择APP权限',
            trigger: 'change'
          }],
          
        },  
        
        
      }
    },
    methods: {

      /**
       * 清楚新建用户用户名字符串的空格
       * @param {Object} val
       */
      trimLr(val) {
        this.newUser.username = val.replace(/\s+/g, "");
      },

      /**
       * 联系方式校验
       */
    //   check_phone() {

    //     let phoneReg = this.newUser.phone
    //     if (this.newUser.phone.length == 11 && this.newUser.phone.indexOf("-") == -1) {
    //       this.maxlengthPhone = 11;
    //     }
    //     if (this.newUser.phone.indexOf("-") != -1) { //座机校验
    //       this.maxlengthPhone = 13;
    //       // let reg = /^((d{3,4})|d{3,4}-|s)?d{7,14}$/;
    //       let reg = /^(0\d{3,4}-\d{7,8})$/
    //       // 0\d{2,3}-\d{7,8}
    //       if (!(reg.test(phoneReg))) {
    //         this.error_input = false
    //       } else {
    //         this.error_input = true;
    //       }
    //     } else {  //手机校验
		  // let reg = /^1[3456789]\d{9}$/
		  // if(!(reg.test(phoneReg))) {
    //         this.error_input = false;
    //       } else {
    //         this.error_input = true;
    //       }
    //       console.log(this.error_input);
    //     }
    //   },

      /**
       * handleFilter 用于请求用户数据
       */
      handleFilter() {
        this.listLoading = true
        userList(this.listQuery).then(res => {
          let data = res.pageData
          this.totalCounts = data.totalCounts
          // 对后端数据进行解析
          this.listData = data.datas.map(item => {

            return {
              entityId: item.entityId,
              userId: item.id,
              username: item.username,
              entityName: item.entityName,
              roleId: item.roleId,
              roleName: item.roleName,
              appAvailable: item.appAvailable,
              phone: item.phone,
              createdate: formatDate(item.createdate),
              lastlogin: item.lastlogin == null ? "" : formatDate(item.lastlogin),
              logintimes: item.logintimes
            }
          })
          this.listLoading = false
        })
      },
      formatAppAuthorityToName(row) {
        if(row.appAvailable in this.appAvailableOptions) 
          return this.appAvailableOptions[row.appAvailable];
        return "未知权限";
      },


      /**
       * @param {Object} done
       * 点击新建框外提示
       */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.cancelEditUser();
          })
          .catch(_ => {});

      },

      /**
       * 取消编辑User
       */
      cancelEditUser() {
        this.dialogFormVisible = false
        this.$refs.editedUser.resetFields;
        console.log(this.editedUser)
      },

      /**
       * handleCreate 加载单位信息
       * @param {Object} row
       */
      handleCreate() {
        this.createUserDialog = true;
        //如果单位选列表项为空，加载单位信息
        if (this.entityIdOptions.length === 0) {
          let entitys = JSON.parse(localStorage.entity)
          for (let k in entitys) {
            this.entityIdOptions.push({
              value: k,
              label: entitys[k]
            })
          }
        }
        // if(this.roleIdOptions.length===0){
        //     getRoles(this.$store.getters['user/entityId']).then(res=>{
        //         let roles=res.data;
        //         this.roleIdOptions=roles.map(item=>{
        //             return{
        //                 value:item.id,
        //                 label:item.name
        //             }
        //         })
        //     })
        // }
      },

      //entity单位发生改变后单位所对应的角色
      entityChange(entityId) {
        //获取当前单位所拥有的权限
        getRoles(entityId).then(res => {
          let roles = res.data;
          this.roleIdOptions = roles.map(item => {
            return {
              name: item.name,
              value: item.id,
              label: item.name
            }
          })
          //可为了新建用户设置除了superadmin以外的所有权限
          this.delRoleAdmin("superadmin");
        });
        //因为重新设置了roleIdOptions，所以需要把newUser的roleId置为null
        this.newUser.roleId = null;
      },
      /**
       * 删除超级管理员角色
       * @param {Object} name
       */
      delRoleAdmin(name) {
        let index = this.roleIdOptions.findIndex(item => {
          if (item.name == name) {
            return true
          }
        })
        if (index != -1) {
          this.roleIdOptions.splice(index, 1);
        }
      },
      createUser() {
        this.$refs.newUser.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'info',
              message: '检查输入'
            });
          } else {

            //请求新建/添加用户
            addUser(this.newUser).then(res => {
              if (res.result === "1") {
                //添加成功
                this.$message({
                  message: res.message,
                  type: 'success'
                });
                //刷新列表数据
                this.handleFilter()
                //隐藏添加用户模态框
                this.createUserDialog = false;
                //重置用户表单数据
                this.$refs.newUser.resetFields();
                
              } else if (res.result === "0") {
                this.$message({
                  message: res.message,
                  type: 'info'
                })
              } else {
                this.$message.error(res.message)
              }
            })


          }
        })
      },

      cancelUser() {

        this.createUserDialog = false
        /* this.newUser = {
          entityId: null,
          username: '',
          password: '',
          rePassword: '',
          roleId: null,
          phone: '',
        }; */
        // resetFields
        // clearValidate
        this.$refs.newUser.resetFields();
      },

      handlePageChange(data) {
        this.listQuery.pageIndex = data.page
        this.listQuery.pageSize = data.limit
        this.handleFilter()
      },
      /**
       * handleEdit 打开编辑模态框
       * @param {Object} row
       */
      handleEdit(row) {
        //加载下拉数据//同handleCreate中 该方法一致
        //因为对于当前登录的用户来说entityIdOptions不会改变，所以与新建功能使用同一个
        if (this.entityIdOptions.length === 0) {
          let entitys = JSON.parse(localStorage.entity)
          for (let k in entitys) {
            this.entityIdOptions.push({
              value: k,//注意此处key为字符串
              label: entitys[k]
            })
          }
        }

        //用户id
        this.editedUser.id = row.userId;
        //设置用户所属单位
        this.editedUser.entityId = row.entityId + "";
        //获取当前单位所拥有的角色权限
        getRoles(this.editedUser.entityId).then(res => {
          let roles = res.data;

          let superadminRoleIndex = -1;

          this.editRoleIdOptions = roles.map((item,index) => {

            if("superadmin" == item.name) {
              superadminRoleIndex = index;
            }

            return {
              name: item.name,
              value: item.id,
              label: item.name
            }
          })
          //如果存在superadmin，则将其删除
          if(superadminRoleIndex) {
            this.editRoleIdOptions.splice(superadminRoleIndex,1);
          }
          //角色id
          this.editedUser.roleId = row.roleId;
          this.editedUser.appAvailable = row.appAvailable;
          //用户名称
          this.editedUser.username = row.username;
          //设置用户
          this.editedUser.phone = row.phone;
          //默认不对密码进行操作
          this.isResetPassword = 0;
          //密码为空
          this.editedUser.password = "";
          //显示编辑用户模态框
          this.dialogFormVisible = true;

        });


      },
      editUser() {
        this.$refs.editedUser.validate(valid=>{
          if(!valid) {
            this.$message({
              type: 'info',
              message: '检查输入'
            });
          } else {
            updateUser(this.editedUser, this.isResetPassword).then(res => {
              if (res.result === "1") {
                this.$message({
                  message: res.message,
                  type: 'success'
                })

                //刷新列表数据
                this.handleFilter()
                //隐藏添加用户模态框
                this.dialogFormVisible = false;
                //重置用户表单数据
                this.$refs.editedUser.resetFields();
              } else {
                this.$message.error(res.message)
              }
              
              // this.handleFilter()
            })
          }
        })
      },
	  offline(){
		  mqttPushUserOffline(this.editedUser).then(res=>{
			 if(res.result == '0'){
			   this.$alert('推送成功！');
			 }else{
			   this.$alert('推送失败');
			 }
		  })
	  },
      /**
       * handleDelete 删除用户
       * @param {Object} row
       */
      handleDelete(row) {
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteUser(row.userId).then(res => {
            if (res.result === "1") {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.handleFilter()
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    mounted() {
      this.handleFilter()
    },
  }
</script>

<style>
</style>
